export const ROW_PAGE_PER_LIST = [
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: 'All', value: -1 },
]
